import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import {
  BooleanCons,
  HttpStatus,
  MessageType,
  NumberCons,
} from '../constants/const';
import { Messages } from '../constants/messages';
import { NotificationMessageComponent } from '../dialogs/notification-message/notification-message.component';
import { TypeIcon } from '../model/device/message.model';
import { IErrorHttp } from '../model/http/commons.model';
import { ValidateSameValues } from '../model/local/details.orders';
import { CommonService } from './common.service';
import { DialogService } from './dialog.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  wasErrorDisplayed = false;

  constructor(
    private dialogService: DialogService,
    private commonService: CommonService
  ) {}
  http(error: IErrorHttp): void {
    const actions: { [key: number]: () => void } = {
      [HttpStatus.unauthorized]: () => this.showDialog(Messages.unauthorized),
      [HttpStatus.timeOut]: () => this.showDialog(Messages.timeout),
      [HttpStatus.connectionRefused]: () =>
        this.showDialog(Messages.connectionRefused),
    };

    const statusToValidate: ValidateSameValues[] = [
      { firstValue: HttpStatus.unauthorized, secondValue: error.status },
      { firstValue: HttpStatus.timeOut, secondValue: error.status },
      { firstValue: HttpStatus.connectionRefused, secondValue: error.status },
    ];

    const isKnownStatus = this.commonService.validateSomeValues(statusToValidate);
    const errorStatus = error.status ?? NumberCons.zero;
    const handler = isKnownStatus ? actions[errorStatus] : undefined;

    (handler ?? (() => this.showDialog(Messages.generic)))();
  }

  private showDialog(message: string): void {
    if (this.wasErrorDisplayed) {
      return;
    }
    this.wasErrorDisplayed = true;
    const config = new MatDialogConfig();
    config.data = {
      textToShow: message,
      typeMessage: MessageType.error,
      typeIcon: TypeIcon.error,
    };

    const dialogRef = this.dialogService.displayDialog(
      NotificationMessageComponent,
      config
    );
    dialogRef.afterClosed().subscribe(() => (this.wasErrorDisplayed = false));
  }
}
